<div class="overlay" *ngIf="IsOtpPopup">
  &nbsp;
</div>
<div *ngIf="localService.languageContent && localService.languageContent.otp_container"
  [ngClass]="IsOtpPopup ? 'message-box-wrapper center-full otp_popup' : ''">
  <div *ngIf="IsOtpPopup">
    <div class="row">
      <div class="col-10">
        {{localService.languageContent.otp_container.otp_verify}}
      </div>
      <div class="col-2" style="text-align: right;">
        <button class="button_icon delete_icon" (click)="onCancel()">cancel</button>
      </div>
    </div>
  </div>
  <div *ngIf="localService.languageContent && localService.languageContent.otp_container">
    <div *ngIf="isShowRequestOtp" style="text-align: center;margin-top: 10%;">
      <button id="{{elementIds.request}}" type="button" class="btn btn-primary" (click)="sendOtp()">{{requestOtpLabel ??
        localService.languageContent.otp_container.request_otp}}</button>
    </div>
    <div *ngIf="!isShowRequestOtp">
      <div class="modal-body modal-body-no-flexible-height" *ngIf="!isPasswordPart">
        <div style="text-align: justify; line-height: 25px; color: darkslategray;">
          {{otpType == 10 ? localService.languageContent.otp_container.otp_title_email
          : (otpType == 11 ? localService.languageContent.otp_container.otp_title_email_support
          : localService.languageContent.otp_container.otp_title)}}
        </div>
        <div style="text-align:center">
          <app-otp-pad *ngIf="isShowOtp" (onFill)="OnOtpFill($event)"></app-otp-pad>
        </div>
        <div *ngIf="message != ''">
          <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'yellowgreen' }">{{message}}</span>
        </div>
      </div>
      <div class="modal-footer" *ngIf="!isPasswordPart">
        <button id="{{elementIds.save}}" type="button" class="btn btn-primary"
          (click)="onVerify()">{{localService.languageContent.common.continue}}</button>
      </div>
    </div>
  </div>
</div>
<app-pwd-change *ngIf="isPasswordPart" [UserId]="userId" [IsPopup]="IsPopup" (onChanged)="onPwdChanged($event)">
</app-pwd-change>